import React from 'react';

import './style.scss';

interface IPropsSimpleTabs {
  list: any[];
  selected: string;
  setSelect: (selected: string) => void;
  onEventClick: () => void;
}

const Switcher: React.FC<IPropsSimpleTabs> = ({ list, selected, setSelect, onEventClick }): JSX.Element => {
  const onSelect = (item: any) => {
    setSelect(item.currency);
    onEventClick();
  };

  return (
    <section className="switcher">
      {list.map((item: any) => (
        <button
          key={item.id}
          className={`item-button ${selected === item.currency ? 'select' : ''}`}
          onClick={() => (selected === item.currency ? {} : onSelect(item))}
          disabled={selected === item.currency}
        >
          <i className="icon" style={{ backgroundImage: `url(/assets/currency-icons/${item.currency}.svg)` }} />
          <span>{item.currency}</span>
        </button>
      ))}

      <div className={`select-bg ${list.find((item: any) => item.currency === selected)?.id}`}></div>
    </section>
  );
};

export default Switcher;
